import { css } from "@emotion/react";
import { Bookshelf } from "../patterns/Bookshelf";
import { ManagementViewTitle } from "../bits/ManagementViewTitle";
import { useTitle } from "../hooks/useTitle";

export const MyShelf = () => {
  useTitle("My Shelf | Compass");
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        gap: 24px;
      `}
    >
      <ManagementViewTitle text="My Shelf" />
      <div
        css={({ breakpoints }) => css`
          padding: 0 70px;
          width: 100%;

          @media (max-width: ${breakpoints.values.xl}px) {
            padding: 0;
          }
        `}
      >
        <Bookshelf />
      </div>
    </div>
  );
};
